var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-card"},[_c('span',{staticClass:"stat-card__label"},[_vm._v("Total de Serviços")]),_c('span',{staticClass:"stat-card__value"},[_vm._v(_vm._s(_vm.total_services || 0))])])}
var staticRenderFns = []

export { render, staticRenderFns }